import React, { useEffect, useState } from "react";
import { Content } from "antd/lib/layout/layout";
import SetupProgress from "../../components/setup/SetupProgress";
import { SetupStatusApi } from "../../api/SetupStatusApi";
import PageLoader from "../../components/sub/PageLoader";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import SetupCompleteModal from "../../components/modal/SetupCompleteModal";
import CompleteSetupApi from "../../api/CompleteSetupApi";
import { useNavigate } from "react-router-dom";
import { setupAccount } from "../../features/SetupAccountSlice";

function SetupAccount() {
  const [progress, setProgress] = useState();
  const [completed, setCompleted] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);
  const proHeight = document.body.clientHeight;
  const userState = useSelector((state) => state.userState.value);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getSetupProgress();
  }, []);

  async function getSetupProgress() {
    const apiResponse = await SetupStatusApi();
    if (apiResponse.success) {
      setProgress(apiResponse.data);
      if (apiResponse.data?.percentage === 100) {
        setCompleted(true);
      }
    }
  }

  async function completeSetup() {
    const apiResponse = await CompleteSetupApi(userState?.corporateId);
    if (apiResponse.success) {
      dispatch(setupAccount(true));
      navigate("/metabase");
    }
  }

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <div
          style={{
            height: proHeight - 64,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {progress ? (
            <>
              <div className="pri-font text-2xl">
                Hi {userState?.firstName}!
              </div>
              <div className="pri-font text-2xl">
                Welcome to Performance Dashboard
              </div>
              <div className="mb-6">
                Complete account setup to continue to the application
              </div>
              <SetupProgress progress={progress} />
              <div className="mb-3 text-xs">
                Once you complete the setup you can't delete or change the order
                of the organizational levels and plan levels.
              </div>
              <Button
                type="primary"
                onClick={() => setCompleteModal(true)}
                disabled={!completed}
              >
                Complete setup
              </Button>
            </>
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <SetupCompleteModal
        visible={completeModal}
        handleCancel={() => setCompleteModal(false)}
        handleOk={() => completeSetup()}
      />
    </>
  );
}

export default SetupAccount;
